module.exports = __webpack_public_path__ + "img/romantic.5467129.jpg";